module.exports = __webpack_public_path__ + "static/media/Section 3 Image.1eae42b6.png";